import React, { useState, useEffect, useRef } from "react";
import { Button, Form } from "semantic-ui-react";
import { Container, Row, Col, Image } from "react-bootstrap";
import { DatePicker, message } from "antd";
import axios from "axios";

function EditProfileForm({ user, setUpdated, isUpdated }) {
  const [newUser, setUser] = useState({});
  const [loading, setLoading] = useState(false);
  const [loadImage, setLoadImage] = useState(false);

  const uploader = useRef(null);

  useEffect(() => {
    setUser(user);
    return () => setUser({});
  }, [user, isUpdated]);

  const showPicker = () => {
    uploader.current.click();
  };

  const handlePickImage = async (event) => {
    const file = event.target.files[0];
    setLoadImage(true);
    const formData = new FormData();
    formData.append("file", file);

    formData.append("upload_preset", "roll_app");

    const options = {
      method: "POST",
      body: formData,
    };

    setUser({
      ...newUser,
      image: URL.createObjectURL(file),
    });

    const results = await fetch(
      `${process.env.REACT_APP_CLOUDINARY_API}/image/upload`,
      options
    );
    const response = await results.json();

    setUser({
      ...newUser,
      image: URL.createObjectURL(file),
      imageUrl: response ? response.secure_url : file,
    });
    setLoadImage(false);
  };

  const handleEditProfile = async () => {
    try {
      setLoading(true);
      const token = localStorage.getItem("token");

      const { image, imageUrl, ...updateUser } = newUser;

      const response = await axios.patch(
        `${process.env.REACT_APP_API_URL}/users`,
        { ...updateUser, image: imageUrl },
        { headers: { token } }
      );

      if (response.status === 200) {
        setLoading(false);
        setUpdated(true);
        message.success("User data updated");
        setUpdated(false);
        return;
      }
    } catch (error) {
      setLoading(false);
      return message.error(error.message);
    }
  };

  return (
    <Container className="d-flex justify-content-between p-4">
      <Row className="w-100">
        <Col
          lg={3}
          className="d-flex h-50 flex-column align-items-center justify-content-between"
        >
          <Row>
            <Col>
              <Image src={newUser?.image} roundedCircle fluid loading="eager" />
              <input
                hidden
                type="file"
                ref={uploader}
                onChange={handlePickImage}
              />
            </Col>
          </Row>
          <Row>
            <Col>
              <Button
                positive
                content="Change image"
                onClick={showPicker}
                loading={loadImage}
              />
            </Col>
          </Row>
        </Col>
        <Col>
          <Form>
            <Container fluid>
              {/* Names row */}
              <Row>
                <Col>
                  <Form.Field>
                    <label>First Name</label>
                    <input
                      placeholder={user.firstName}
                      onChange={({ target }) =>
                        setUser({ ...newUser, firstName: target.value })
                      }
                    />
                  </Form.Field>
                </Col>
                <Col>
                  <Form.Field>
                    <label>Last Name</label>
                    <input
                      placeholder={user.lastName}
                      onChange={({ target }) =>
                        setUser({ ...newUser, lastName: target.value })
                      }
                    />
                  </Form.Field>
                </Col>
              </Row>
              {/* Names row */}

              {/* Email row */}
              <Form.Field>
                <label>Email</label>
                <input
                  placeholder={user.email}
                  onChange={({ target }) =>
                    setUser({ ...newUser, email: target.value })
                  }
                />
              </Form.Field>
              {/* Email row */}

              {/* Addresses row */}
              <Row>
                <Col>
                  <Form.Field>
                    <label>Phone Number</label>
                    <input
                      placeholder={user.phone}
                      onChange={({ target }) =>
                        setUser({ ...newUser, phone: target.value })
                      }
                    />
                  </Form.Field>
                </Col>
                <Col>
                  <Form.Field>
                    <label>Address</label>
                    <input
                      placeholder={user.address}
                      onChange={({ target }) =>
                        setUser({ ...newUser, address: target.value })
                      }
                    />
                  </Form.Field>
                </Col>
              </Row>
              {/* Addresses row */}

              <Form.Field>
                <label>Role</label>
                <input placeholder={user.role} value={user.role} disabled />
              </Form.Field>

              <Form.Field>
                <label>Date of birth</label>
                <DatePicker
                  bordered
                  style={{
                    width: "100%",
                  }}
                  // onChange={(e) => setUser({ ...newUser, dob: e._d })}
                  onChange={({ _d }) => setUser({ ...newUser, dob: _d })}
                  placeholder={`${new Date(user.dob).getFullYear()}-${
                    new Date(user.dob).getMonth() + 1
                  }-${new Date(user.dob).getDate()}`}
                />
              </Form.Field>
              <Button
                primary
                circular
                onClick={handleEditProfile}
                loading={loading}
              >
                Save Changes
              </Button>
            </Container>
          </Form>
        </Col>
      </Row>
    </Container>
  );
}

export default EditProfileForm;
